<template>
  <sp-autocomplete
    placeholder="Start typing..."
    return-object
    no-filter
    no-data-text="No physicians found"
    item-value="id"
    :items="physicians"
    :loading="isLoadingPhysicians"
    @input="onPhysicianSelect"
    @update-search="debouncedOnPhysicianUpdateSearch"
  />
</template>

<script setup>
import { useDebounceFn } from "@vueuse/core";
import { ref } from "vue";
import { usePhysicianApi } from "../api/physician";

const { search } = usePhysicianApi();

const emit = defineEmits(["update-selected"]);

const physicians = ref([]);
const isLoadingPhysicians = ref(false);

const selectedPhysician = ref(null);

async function onPhysicianUpdateSearch({ detail }) {
  const [q] = detail;

  if (!q) {
    physicians.value = [];
    return;
  }

  // If the user has already selected a physician, don't search again
  if (selectedPhysician.value && selectedPhysician.value.title === q) {
    return;
  }

  try {
    isLoadingPhysicians.value = true;
    physicians.value = await search(q);
  } catch (error) {
    console.error(error);
  } finally {
    isLoadingPhysicians.value = false;
  }
}

// Debounce the search function so we don't overwhelm the API
const debouncedOnPhysicianUpdateSearch = useDebounceFn(onPhysicianUpdateSearch);

function onPhysicianSelect({ detail }) {
  const [physician] = detail;
  selectedPhysician.value = physician;
  emit("update-selected", physician.id);
}
</script>
